var hu = {
  "Add Upsell.com to your ": "Upsell.com hozzáadása: ",
  "All time": "Teljes időszak",
  "and select": "és válassza",
  "button": "gombra",
  "Cart drawer page": "Kosár fiók oldal",
  "Cart page": "Kosár oldal",
  "Check status": "Állapot ellenőrzése",
  "Checkout page": "Pénztár oldal",
  "Click": "Kattintson",
  "Click on": "Kattintson",
  "Click the": "Kattintson a",
  "Custom slot": "Egyedi hely",
  "Custom slots": "Egyedi helyek",
  "Custom Slots": "Egyedi helyek",
  "contact support.": "lépjen kapcsolatba a támogatással.",
  "from the right sidebar": "a jobb oldali oldalsávból",
  "Go to your Cart drawer page": "Menjen a Kosár fiók oldalra",
  "Go to your Cart page": "Menjen a Kosár oldalra",
  "Go to your Checkout page": "Menjen a Pénztár oldalra",
  "Go to your Order status page": "Menjen a Rendelés állapota oldalra",
  "Go to your Post purchase page": "Menjen a Vásárlás utáni oldalra",
  "Go to your Product page": "Menjen a Termék oldalra",
  "Go to your Thank you page": "Menjen a Köszönő oldalra",
  "items": "tételek",
  "in the left sidebar": "a bal oldali oldalsávban",
  "Last 12 months": "Elmúlt 12 hónap",
  "Last 30 days": "Elmúlt 30 nap",
  "Last 365 days": "Elmúlt 365 nap",
  "Last 7 days": "Elmúlt 7 nap",
  "Last 90 days": "Elmúlt 90 nap",
  "Last month": "Múlt hónap",
  "Last year": "Tavaly",
  "Make sure": "Győződjön meg róla",
  "Need assistance? Contact our support team for help.": "Segítségre van szüksége? Lépjen kapcsolatba ügyfélszolgálatunkkal.",
  "Order status page": "Rendelés állapota oldal",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Alkalmazásunk jelenleg egy kis varázslaton megy keresztül, hogy javítsuk az élményt.",
  "Post purchase page": "Vásárlás utáni oldal",
  "Product page": "Termék oldal",
  "Save": "Mentés",
  "Scroll to the bottom and select": "Görgessen az aljára és válassza",
  "Select": "Válassza ki",
  "Success. Please continue.": "Sikeres. Kérjük, folytassa.",
  "Thank you page": "Köszönő oldal",
  "The Upsell.com team.": "Az Upsell.com csapata.",
  "The Upsell.com widget is not placed on ": "Az Upsell.com widget nincs elhelyezve a ",
  ". Please follow the steps above or ": " oldalon. Kérjük, kövesse a fenti lépéseket, vagy ",
  "Today": "Ma",
  "toggle is on": "a kapcsoló be van kapcsolva",
  "Total": "Összesen",
  "under": "alatt",
  "We apologize for any inconvenience caused,": "Elnézést kérünk az okozott kellemetlenségért,",
  "We apologize for any inconvenience caused.": "Elnézést kérünk az okozott kellemetlenségért.",
  "We'll be done in a few minutes!": "Néhány percen belül végzünk!",
  "We're improving our services!": "Javítjuk szolgáltatásainkat!",
  "Widget already added": "Widget már hozzáadva",
  "Yesterday": "Tegnap",
  "You placed the widget on the ": "Elhelyezte a widgetet a ",
  ", but you didn't save it in Shopify editor. Please go back to ": " oldalon, de nem mentette el a Shopify szerkesztőben. Kérjük, térjen vissza a ",
  " and save the changes.": " oldalra és mentse a változtatásokat."
};

export { hu as default };
//# sourceMappingURL=hu.json.js.map
